import { TranslationKey } from '../functions/i18n';

export const fr: Record<TranslationKey, string> = {
  'nav.records': 'Dossiers',
  'nav.meds': 'Médicaments',
  'nav.guide': 'Bibliothèque',
  'nav.options': 'Rappels',
  'topbar.welcome': 'Bienvenue',
  'splash.tagline': 'Master Pet Health. Conquer the Fellowship.',
  'records.tab.todayEntry': 'Quotidien',
  'records.tab.allCards': 'Historique',
  'records.tab.worksheet': 'Données',
  'meds.title': 'Médicaments',
  'meds.empty': 'Aucun médicament ajouté',
  'trends.title': 'Trends',
  'trends.noDataTitle': 'Aucune donnée',
  'trends.noDataBody': 'Commencez à enregistrer vos constantes dans Cartes pour voir les tendances ici.',
  'trends.moreDataNeeded': 'Plus de données nécessaires',
  'trends.moreDataNeededBody': 'Nous avons besoin d\'au moins 3 jours de données pour générer des tendances. Continuez !',
  'trends.avgWeight': 'Poids moyen',
  'trends.avgHeartRate': 'Avg Heart Rate',
  'trends.avgRespRate': 'Fréq. respiratoire moy.',
  'trends.avgMucousMembrane': 'Muqueuses moyennes',
  'trends.avgWaterIntake': 'Apport hydrique moyen',
  'trends.avgTemperature': 'Température moyenne',
  'trends.weightTrend': 'Weight Trend',
  'trends.heartRateTrend': 'Heart Rate Trend',
  'trends.respRateTrend': 'Respiratory Rate Trend',
  'trends.mucousMembraneTrend': 'Répartition des muqueuses',
  'trends.fluidIntakeTrend': 'Water Intake Trend',
  'trends.foodIntakeTrend': 'Tendance apport alimentaire',
  'trends.avgFoodIntake': 'Apport alimentaire moyen',
  'trends.day': 'jour',
  'trends.days': 'jours',
  'trends.tooltipWeight': 'Poids',
  'trends.tooltipFluid': 'Apport liquidien',
  'trends.tooltipFood': 'Apport alimentaire',
  'trends.tooltipHeartRate': 'Heart Rate',
  'trends.tooltipRespRate': 'Resp. Rate',
  'trends.tooltipMucousMembrane': 'Muqueuses',
  'trends.fluidBalanceTrend': 'Tendance de la balance hydrique',
  'trends.tempTrend': 'Tendance de la température',
  'trends.moodTrend': "Tendance de l'humeur",
  'trends.mucousMembrane.pink': 'Roses',
  'trends.mucousMembrane.red': 'Rouges',
  'trends.mucousMembrane.blue': 'Bleues',
  'trends.mucousMembrane.white': 'Blanches',
  'trends.noMucousMembraneData': 'Aucune donnée sur les muqueuses n’a encore été enregistrée sur cette période.',
    'trends.moodLabel.terrible': 'Très mal',
    'trends.moodLabel.notGreat': 'Pas top',
    'trends.moodLabel.okay': 'Ça va',
    'trends.moodLabel.good': 'Bien',
    'trends.moodLabel.great': 'Excellent',
  'trends.tooltipFluidBalance': 'Balance hydrique (Entrée − Sortie)',
  'trends.tooltipTemp': 'Température',
  'trends.tooltipMood': 'Humeur',
  'trends.customise': 'Personnaliser',
  'trends.resetLayout': 'Réinitialiser la mise en page',
  'trends.viewPlans': 'Voir les forfaits',
  'trends.trendsLockedTitle': 'Les tendances sont une fonctionnalité payante',
  'trends.trendsLockedBody': 'Abonnez-vous à KodaCare pour suivre votre poids, tension artérielle, apport liquidien et plus encore.',
  'trends.lifetimeLockedTitle': 'Fonctionnalité Lifetime',
  'trends.lifetimeLockedBody': 'Passez au forfait Lifetime pour débloquer les tendances de fréquence respiratoire, des muqueuses et de la température — avec une mise en page entièrement personnalisable.',
  'guide.digestLockedTitle': 'Digest Mensuel Rénal',
  'guide.digestLockedBody': 'Passez au forfait Lifetime pour recevoir notre newsletter mensuelle sélectionnée — les actualités les plus marquantes en technologie rénale, recherche médicamenteuse et témoignages de la communauté transplantée.',
  'options.title': 'Notifications',
  'options.appPreferences': "Préférences de l'application",
  'options.language': 'Langue',
  'options.units': 'Unités',
  'options.metric': 'Métrique',
  'options.imperial': 'Impérial',
  'options.dateFormat': 'Format de date',
  'options.timeFormat': "Format de l'heure",
  'options.transplant': 'Transplantation',
  'options.editProfile': 'Modifier le profil',
  'options.saveToHomeScreen': "Installer l'application",
  'options.logOut': 'Déconnexion',
  'options.fullName': 'Nom complet',
  'options.profession': 'Profession',
  'options.professionPlaceholder': 'ex. Infirmier, Chirurgien',
  'options.emailAddress': 'Adresse e-mail',
  'options.emailCannotChange': "L'e-mail ne peut pas être modifié.",
  'options.transplantDate': 'Date de transplantation',
  'options.changePassword': 'Changer le mot de passe',
  'options.deleteAccount': 'Supprimer le compte',
  'options.cancel': 'Annuler',
  'options.saveChanges': 'Enregistrer',

  'login.email': 'E-mail',
  'login.password': 'Mot de passe',
  'login.forgotPassword': 'Mot de passe oublié ?',
  'login.signIn': 'Se connecter',
  'login.continueWithGoogle': 'Continuer avec Google',
  'login.noAccount': "Vous n'avez pas de compte ?",
  'login.register': "S'inscrire",
  'login.or': 'ou',
  'login.rememberMe': 'Se souvenir de moi pendant 30 jours',
  'forgot.title': 'Réinitialiser votre mot de passe',
  'forgot.subtitle': 'Saisissez votre e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe.',
  'forgot.checkInboxTitle': 'Vérifiez votre boîte de réception',
  'forgot.checkInboxBody': 'Nous avons envoyé un lien de réinitialisation du mot de passe à {email}. Suivez le lien pour choisir un nouveau mot de passe.',
  'forgot.spamHint': "Vous ne l'avez pas reçu ? Vérifiez votre dossier spam ou courrier indésirable.",
  'forgot.backToSignIn': 'Retour à la connexion',
  'forgot.sendResetLink': 'Envoyer le lien de réinitialisation',
  'forgot.rememberPassword': 'Vous vous souvenez de votre mot de passe ?',
  'forgot.legal': "En vous connectant, vous acceptez nos Conditions d'utilisation et notre Politique de confidentialité.",
  'forgot.errorNoAccount': 'Aucun compte trouvé avec cette adresse e-mail.',
  'forgot.errorNetwork': 'Erreur réseau. Vérifiez votre connexion puis réessayez.',
  'forgot.errorGeneric': 'Impossible d’envoyer l’e-mail de réinitialisation. Veuillez réessayer.',
  'verify.title': 'Vérifiez votre e-mail',
  'verify.subtitle': 'Nous avons envoyé un lien de vérification à {email}. Cliquez sur le lien dans cet e-mail, puis revenez vous connecter.',
  'verify.errorResend': 'Impossible de renvoyer l’e-mail. Veuillez réessayer dans un instant.',
  'verify.resent': 'E-mail de vérification renvoyé — vérifiez votre boîte de réception.',
  'verify.emailSent': 'E-mail envoyé ✓',
  'verify.resend': 'Renvoyer l’e-mail de vérification',
  'verify.backToSignIn': 'Retour à la connexion',
  'verify.spamHint': "Vous ne l'avez pas reçu ? Vérifiez votre dossier spam ou courrier indésirable.",
  'authAction.loading': 'Validation de votre lien…',
  'authAction.error.missingInfo': 'Ce lien de confirmation ne contient pas les informations requises.',
  'authAction.error.unsupportedMode': 'Ce type d’action n’est pas encore pris en charge sur cette page.',
  'authAction.error.expired': 'Ce lien a expiré. Veuillez en demander un nouveau.',
  'authAction.error.invalid': 'Ce lien est invalide ou a déjà été utilisé.',
  'authAction.error.userDisabled': 'Ce compte est désactivé.',
  'authAction.error.userNotFound': 'Aucun compte trouvé pour ce lien.',
  'authAction.error.weakPassword': 'Votre nouveau mot de passe est trop faible. Veuillez en choisir un plus fort.',
  'authAction.error.generic': 'Nous n’avons pas pu traiter ce lien. Veuillez en demander un nouveau et réessayer.',
  'authAction.error.resetInvalid': 'Ce lien de réinitialisation est invalide. Veuillez en demander un nouveau.',
  'authAction.error.passwordMin': 'Le mot de passe doit contenir au moins 8 caractères.',
  'authAction.error.passwordMismatch': 'Les mots de passe ne correspondent pas.',
  'authAction.verifySuccessTitle': 'E-mail confirmé',
  'authAction.verifySuccessBody': 'Votre e-mail est maintenant vérifié. Vous pouvez vous connecter pour continuer.',
  'authAction.recoverSuccessTitle': 'E-mail restauré',
  'authAction.recoverSuccessBody': 'La modification de votre e-mail a été annulée avec succès. Veuillez vous reconnecter.',
  'authAction.continue': 'Continuer',
  'authAction.goToSignIn': 'Aller à la connexion',
  'authAction.resetTitle': 'Définir un nouveau mot de passe',
  'authAction.resetBody': 'Réinitialisation du mot de passe pour {email}',
  'authAction.newPassword': 'Nouveau mot de passe',
  'authAction.confirmNewPassword': 'Confirmer le nouveau mot de passe',
  'authAction.updatePassword': 'Mettre à jour le mot de passe',
  'authAction.resetSuccessTitle': 'Mot de passe mis à jour',
  'authAction.resetSuccessBody': 'Votre mot de passe a été réinitialisé avec succès.',
  'authAction.signIn': 'Se connecter',
  'authAction.linkUnavailableTitle': 'Lien indisponible',
  'authAction.requestNewResetLink': 'Demander un nouveau lien de réinitialisation',
  'authAction.backToSignIn': 'Retour à la connexion',
  'register.title': 'Créez votre compte',
  'register.fullName': 'Nom complet',
  'register.operationDate': 'Date de greffe / opération',
  'register.email': 'E-mail',
  'register.password': 'Mot de passe',
  'register.confirmPassword': 'Confirmer le mot de passe',
  'register.createAccount': 'Créer un compte',
  'register.haveAccount': 'Vous avez déjà un compte ?',
  'register.signIn': 'Se connecter',
  'guide.comingSoon': 'Bientôt disponible',
  'guide.motivation': 'Vous pouvez le faire ! Revenez encore plus fort.',
  // Records page
  'records.todaysOverview': "Aperçu d'aujourd'hui",
  'records.selectedDayOverview': 'Aperçu du jour sélectionné',
  'records.weight': 'Poids',
  'records.fluids': 'Apport',
  'records.fluidIntake': 'Apport liquidien',
  'records.foodIntake': 'Apport alimentaire',
  'records.urineOutput': 'Débit urinaire',
  'records.saveWeight': 'Enregistrer le poids',
  'records.undoWeight': 'Annuler le poids',
  'records.weightRecorded': 'Poids enregistré',
  'records.weightRecordedToday': "Poids enregistré aujourd'hui",
  'records.add': 'Ajouter',
  'records.total': 'total',
  'records.morningVitals': 'Constantes du matin',
  'records.afternoonVitals': "Constantes de l'après-midi",
  'records.morningVitalsRecorded': 'Constantes du matin enregistrées',
  'records.afternoonVitalsRecorded': "Constantes de l'après-midi enregistrées",
  'records.saveVitals': 'Enregistrer les constantes',
  'records.resetTodaysData': "Réinitialiser les données d'aujourd'hui",
  'records.resetConfirmMessage': "Toutes les données d'aujourd'hui seront supprimées. Cette action est irréversible.",
  'records.dailyLimitReached': 'Limite journalière atteinte (9999ml)',
  'records.newEntry': 'Nouvelle entrée',
  'records.addNewEntry': 'Ajouter une entrée',
  'records.saveEntry': "Enregistrer l'entrée",
  'records.cancel': 'Annuler',
  'records.date': 'Date',
  'records.morning': 'Matin',
  'records.afternoon': 'Après-midi',
  'records.daily': 'Quotidien',
  'records.bpSystolic': 'PA systolique',
  'records.bpDiastolic': 'PA diastolique',
  'records.pulse': 'Pouls',
  'records.temp': 'Temp.',
  'records.downloadCsvFor': 'Télécharger CSV pour :',
  'records.thisWeek': 'Cette semaine',
  'records.thisMonth': 'Ce mois',
  'records.thisYear': 'Cette année',
  'records.shareDataTitle': 'Partager les données avec le médecin',
  'records.dataCopiedToClipboard': 'Données copiées dans le presse-papiers ! Vous pouvez les coller dans un e-mail ou message.',
  'records.noLogEntriesYet': 'Aucune entrée pour le moment',
  'records.fillAtLeastOneField': 'Veuillez remplir au moins un champ',
  'records.fluid': 'Liquide',
  'records.amBp': 'PA matin',
  'records.amPulse': 'Pouls matin',
  'records.amTemp': 'Temp. matin',
  'records.pmBp': 'PA après-midi',
  'records.pmPulse': 'Pouls après-midi',
  'records.pmTemp': 'Temp. après-midi',
  'records.vitals': 'Constantes',
  'records.vitalsTime': 'Constantes :',
  'records.filterBy': 'Filtrer par',
  'records.week': 'Semaine',
  'records.month': 'Mois',
  'records.year': 'Année',
  'records.entry': 'entrée',
  'records.entries': 'entrées',
  'records.today': "Aujourd'hui",
  'records.fluidIn': 'Liquide entrant',
  'records.deleteLogEntry': 'Supprimer cette entrée ?',
  'records.undoWeightEntry': 'Annuler entrée de poids',
  'records.undoLastFluidEntry': 'Annuler dernière entrée de liquide',
  'records.undoLastUrineEntry': 'Annuler dernière entrée urinaire',
  'records.toolbar.addNote': '+ Ajouter une note',
  'records.toolbar.editNote': 'Modifier la note',
  'records.toolbar.intake': 'Apports',
  'records.toolbar.saveNote': 'Enregistrer la note',
  'records.toolbar.updateNote': 'Mettre à jour la note',
  'records.toolbar.notesPlaceholder': 'À noter — toux, éternuements, stress lié à des événements.\nou\nChangements suivants — écoulements, sommeil, appétit, consommation d\'eau.',
  'records.toolbar.add': 'Ajouter',
  'records.toolbar.save': 'Enregistrer',
  'records.undoMorningVitals': 'Annuler constantes du matin',
  'records.undoAfternoonVitals': "Annuler constantes de l'après-midi",
  'records.amount': 'Quantité',
  'records.tab.documents': 'Coffre',
  'records.documentsTitle': 'Coffre de documents',
  'records.documentsSubtitle': 'Conservez vos bilans, scans et courriers en un seul endroit sécurisé.',
  'records.searchDocuments': 'Rechercher des documents…',
  'records.uploadDocument': 'Téléverser un fichier',
  'records.takePhoto': 'Prendre une photo',
  'records.maxFilesReached': 'Limite de fichiers atteinte pour ce compte.',
  'records.categoryAll': 'Tous',
  'records.bucketLabs': 'Bilans',
  'records.bucketScans': 'Scans',
  'records.bucketLetters': 'Courriers du néphrologue',
  'records.bucketDischarge': 'Documents de sortie',
  'records.bucketPrescriptions': 'Ordonnances',
  'records.bucketOther': 'Autre',
  'records.noDocumentsYet': 'Aucun document pour le moment',
  'records.titleOptional': 'Titre (optionnel)',
  'records.noteOptional': 'Note (optionnelle)',
  'records.documentDate': 'Date du document',
  'records.uploading': 'Téléversement…',
  'records.openFile': 'Ouvrir',
  'records.deleteFile': 'Supprimer',
  'records.deleteFileConfirm': 'Supprimer ce fichier du coffre ?',
  'records.dateAlreadyHasEntry': 'Cette date a déjà une entrée. Utilisez le bouton modifier dans le tableau.',
  'records.deleteEntry': 'Supprimer l\'entrée',
  'records.deleteEntryConfirm': 'Êtes-vous sûr de vouloir supprimer toutes les données de cette date?',
  'records.editEntry': 'Modifier l\'entrée',
  'records.observations': 'Observations',
  'records.howAreYouFeeling': 'Comment vous sentez-vous aujourd\'hui ?',
  'records.observationsPlaceholder': 'À noter — toux, éternuements, stress lié à des événements.\nou\nChangements suivants — écoulements, sommeil, appétit, consommation d\'eau.',
  'records.saveObservations': 'Enregistrer les observations',
  'records.observationsRecorded': 'Observations enregistrées',
  'records.undoObservations': 'Annuler les observations',
  'records.moodTerribleLabel': 'Très mal',
  'records.moodBadLabel': 'Pas très bien',
  'records.moodOkayLabel': 'Moyen',
  'records.moodGoodLabel': 'Bien',
  'records.moodGreatLabel': 'Très bien',
  'records.noObservations': 'Aucune observation',
  'records.mood': 'Humeur',
  // Notification Center
  'notifications.title': 'Tous les rappels',
  'notifications.allReminders': 'Tous les rappels',
  'notifications.storageNote': 'Les 5 derniers jours de rappels sont affichés.',
  'notifications.new': 'nouveau',
  'notifications.markAllRead': 'Tout marquer comme lu',
  'notifications.allCaughtUp': 'Tout est à jour !',
  'notifications.clearAll': 'Tout effacer',
  'notifications.clearAllConfirm': 'Appuyer à nouveau pour tout effacer',
  // Delete Confirm Modal
  'deleteConfirm.defaultTitle': 'Supprimer cet élément ?',
  'deleteConfirm.cancel': 'Annuler',
  'deleteConfirm.delete': 'Supprimer',
  'deleteConfirm.dontShowAgain': 'Ne plus afficher',
  // Settings Panel
  'settings.title': 'Paramètres',
  'settings.preferences': 'Préférences',
  'settings.language': 'Langue',
  'settings.units': 'Unités',
  'settings.metric': 'Métrique',
  'settings.imperial': 'Impérial',
  'settings.dateFormat': 'Format de date',
  'settings.timeFormat': 'Format d\'heure',
  'settings.logOut': 'Déconnexion',
  'settings.editProfile': 'Modifier le profil',
  'settings.fullName': 'Nom complet',
  'settings.profession': 'Profession',
  'settings.professionPlaceholder': 'ex. Infirmier, Chirurgien',
  'settings.emailAddress': 'Adresse e-mail',
  'settings.emailCannotChange': 'L\'e-mail ne peut pas être modifié.',
  'settings.transplantDate': 'Date de transplantation',
  'settings.changePassword': 'Changer le mot de passe',
  'settings.deleteAccount': 'Supprimer le compte',
  'settings.deleteAccountConfirm': 'Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible.',
  'deleteAccount.title': 'Supprimer votre compte ?',
  'deleteAccount.bullet1': 'Vous serez déconnecté immédiatement et ne pourrez plus vous connecter.',
  'deleteAccount.bullet2': 'Vos données de santé, médicaments et toutes vos données personnelles seront définitivement supprimés dans les 30 jours.',
  'deleteAccount.bullet3': 'Les abonnements actifs ne seront pas annulés automatiquement — veuillez les annuler séparément dans les Paramètres.',
  'deleteAccount.footer': 'Cette action est irréversible.',
  'deleteAccount.confirm': 'Oui, supprimer mon compte',
  'deleteAccount.cancel': 'Conserver mon compte',
  'settings.cancel': 'Annuler',
  'settings.saveChanges': 'Enregistrer',
  // Meds page
  'meds.removeMedication': 'Supprimer le médicament',
  'meds.removeConfirm': 'Êtes-vous sûr de vouloir supprimer ce médicament ?',
  'meds.medCount': 'méd.',
  'meds.medsCount': 'méds.',
  'meds.remindersEnabled': 'Rappels activés',
  'meds.remindersDisabled': 'Rappels désactivés',
  'meds.addMedication': 'Ajouter un médicament',
  'meds.cancel': 'Annuler',
  'meds.medicationName': 'Nom du médicament',
  'meds.medicationNamePlaceholder': 'ex. Tacrolimus',
  'meds.dosage': 'Dosage',
  'meds.dosagePlaceholder': 'ex. 1',
  'meds.timeslots': 'Horaires',
  'meds.addTime': '+ Ajouter une heure',
  'meds.type': 'Type',
  'meds.shapeCapsule': 'Gélule',
  'meds.shapeOval': 'Ovale',
  'meds.shapeTwoPart': 'Deux parties',
  'meds.shapeDiamond': 'Losange',
  'meds.shapeRound': 'Ronde',
  'meds.shapeFlat': 'Plate',
  'meds.shapeTriangle': 'Triangle',
  'meds.pillColour': 'Couleur du comprimé',
  'meds.customColour': 'Couleur personnalisée',
  'meds.fillAllFields': 'Veuillez remplir tous les champs, y compris au moins un horaire',
  'meds.edit': 'Modifier',
  'meds.delete': 'Supprimer',
  'meds.duplicate': 'Dupliquer',
  'meds.dropHere': 'Déposer ici pour déplacer',
  'meds.editMedication': 'Modifier le médicament',
  'meds.saveChanges': 'Enregistrer',
  'contacts.edit': 'Modifier',
  'contacts.delete': 'Supprimer',
  'contacts.editContact': 'Modifier le contact',
  'contacts.addContact': 'Ajouter un contact',
  'contacts.cancel': 'Annuler',
  'contacts.saveChanges': 'Enregistrer',
  'contacts.saveContact': 'Enregistrer le contact',
  'contacts.name': 'Nom',
  'contacts.phoneNumber': 'Téléphone',
  'contacts.email': 'E-mail',
  'contacts.nephrologist': 'Néphrologue',
  'contacts.pharmacy': 'Pharmacie',
  'contacts.emergency': 'Urgence',
  'contacts.other': 'Autre',
  'contacts.nameRequired': 'Le nom est requis',
  'contacts.phoneRequired': 'Le numéro de téléphone est requis',
  'contacts.deleteContact': 'Supprimer le contact',
  'contacts.deleteContactMsg': 'Voulez-vous vraiment retirer ce contact de votre équipe ?',
  'contacts.addNewContact': 'Ajouter un nouveau contact',
  'contacts.noContacts': 'Aucun contact ajouté',
  'contacts.addCareTeam': 'Touchez le bouton ci-dessus pour ajouter votre équipe',
  'contacts.sortRecent': 'Plus récent',
  'contacts.sortAlpha': 'Alphabétique',
  'records.shareCard': 'Partager la fiche',
  'records.undoObservation': 'Annuler l\'observation',
  // Notification settings
  'options.notifications': 'Notifications',
  'options.notificationsAll': 'Toutes',
  'options.notificationsLogs': 'Journaux',
  'options.notificationsMeds': 'Médicaments',
  'options.notificationsNone': 'Aucune',
  'options.subscription': 'Abonnement',
  'options.subscriptionSubtitle': 'Échéancier de facturation et détails de renouvellement.',
  'options.subscriptionPlan': 'Formule',
  'options.subscriptionStatus': 'Statut',
  'options.subscriptionStarted': 'Commencé le',
  'options.subscriptionNextPayment': 'Prochain paiement',
  'options.subscriptionExpires': 'Expire le',
  'options.subscriptionNoActive': 'Aucun abonnement actif',
  'options.subscriptionUnavailable': 'Non disponible',
  'account.title': 'Paramètres du compte',
  'account.subtitle': 'Consultez votre profil et gérez vos options d’abonnement.',
  'account.profile': 'Profil',
  'account.profileSubtitle': 'Ton nom, les détails de ton animal et ta carte médicale',
  'account.profileSaved': 'Profil enregistré.',
  'account.profileSaveError': 'Échec de l’enregistrement du profil. Veuillez réessayer.',
  'account.savingProfile': 'Enregistrement…',
  'account.saveProfile': 'Enregistrer le profil',
  'account.openDashboard': 'Ouvrir le tableau de bord',
  'account.starterTrial': 'Starter (Essai)',
  'account.expired': 'Expiré',
  'account.loading': 'Chargement…',
  'account.trialDaysLeft': 'Essai — {days} jour{s} restant{s}',
  'account.expiredDaysLeft': 'Expiré — {days} jour{s} pour vous réabonner',
  'account.currentPlan': 'Forfait actuel',
  'account.fetchingBilling': 'Récupération de vos dernières informations de facturation.',
  'account.manageSubscription': 'Gérer l’abonnement',
  'account.security': 'Compte & Sécurité',
  'account.memberSince': 'Membre depuis',
  'account.lastLogin': 'Dernière connexion',
  'account.passwordResetSent': 'E-mail de réinitialisation envoyé — vérifiez votre boîte de réception.',
  'account.resetPassword': 'Réinitialiser le mot de passe',
  'account.resetPasswordEmailError': 'Impossible d’envoyer l’e-mail de réinitialisation. Veuillez réessayer.',
  'account.deleteRequiresRecentLogin': 'Pour des raisons de sécurité, déconnectez-vous puis reconnectez-vous avant de supprimer votre compte.',
  'account.deleteFailed': 'Échec de la suppression du compte. Veuillez réessayer.',
  'account.deleting': 'Suppression…',
  'account.dataPrivacy': 'Données et confidentialité',
  'account.exportDescription': 'Vous pouvez exporter toutes les données liées à votre compte au format CSV.',
  'account.preparingExport': 'Préparation de l’export…',
  'account.downloadAllData': 'Télécharger toutes mes données',
  'options.notificationSettings': 'Rappels',
  'options.remindersSubtitle': 'Alertes médicaments & notifications push',
  'options.permissions': 'Autorisations :',
  'options.activate': 'Activer :',
  'options.logReminderTimes': 'Heures de rappel des journaux :',
  'options.logReminderTime': 'Heure de rappel :',
  'options.permissionGrant': 'Accorder la permission',
  'options.browserBlockedHelp': 'Les notifications sont bloquées par votre navigateur. Pour les activer, cliquez sur l’icône cadenas/info dans la barre d’adresse et autorisez les notifications pour ce site.',
  'options.appOn': 'App : Activée',
  'options.appOff': 'App : Désactivée',
  'options.browserAllowed': 'Navigateur : Autorisé',
  'options.browserUnsupported': 'Navigateur : Non pris en charge',
  'options.browserBlocked': 'Navigateur : Bloqué',
  'options.browserNotAsked': 'Navigateur : Non demandé',
  'options.activityTitle': 'Activité',
  // Lab Glossary
  'guide.labGlossary.intro': 'Comprenez les marqueurs biologiques courants lors du suivi post-transplantation. Ces informations sont éducatives — discutez toujours de vos résultats avec votre équipe de transplantation.',
  'guide.labGlossary.search': 'Rechercher les marqueurs…',
  'guide.labGlossary.all': 'Tous',
  'guide.labGlossary.noMarkersFound': 'Aucun marqueur trouvé.',
  'guide.labGlossary.referenceRange': 'Plage de référence typique',
  'guide.labGlossary.note': '⚠️ Remarque',
  'guide.labGlossary.marker.creatinine.name': 'Creatinine',
  'guide.labGlossary.marker.creatinine.abbr': 'CREA',
  'guide.labGlossary.marker.creatinine.category': 'Kidney & Urinary',
  'guide.labGlossary.marker.creatinine.why': 'A core kidney marker in dogs and cats. Higher values can suggest reduced kidney filtration, but can also rise with dehydration.',
  'guide.labGlossary.marker.creatinine.typical': 'Dog: ~0.5–1.8 mg/dL · Cat: ~0.8–2.4 mg/dL (lab dependent).',
  'guide.labGlossary.marker.creatinine.note': 'Always interpret with SDMA, BUN, urine concentration, and hydration status.',
  'guide.labGlossary.marker.egfr.name': 'SDMA',
  'guide.labGlossary.marker.egfr.abbr': 'SDMA',
  'guide.labGlossary.marker.egfr.category': 'Kidney & Urinary',
  'guide.labGlossary.marker.egfr.why': 'Symmetric dimethylarginine can rise earlier than creatinine and helps detect early kidney changes.',
  'guide.labGlossary.marker.egfr.typical': 'Usually <14 µg/dL in many pet labs.',
  'guide.labGlossary.marker.egfr.note': 'Persistent increases are more meaningful than a one-off value.',
  'guide.labGlossary.marker.bun.name': 'Blood Urea Nitrogen',
  'guide.labGlossary.marker.bun.abbr': 'BUN / Urea',
  'guide.labGlossary.marker.bun.category': 'Kidney & Urinary',
  'guide.labGlossary.marker.bun.why': 'BUN reflects protein waste handling. It can rise with kidney disease, dehydration, GI bleeding, or high-protein diets.',
  'guide.labGlossary.marker.bun.typical': 'Dog: ~7–27 mg/dL · Cat: ~16–36 mg/dL (lab dependent).',
  'guide.labGlossary.marker.tacrolimus.name': 'ALP (Alkaline Phosphatase)',
  'guide.labGlossary.marker.tacrolimus.abbr': 'ALP',
  'guide.labGlossary.marker.tacrolimus.category': 'Liver',
  'guide.labGlossary.marker.tacrolimus.why': 'ALP can increase with liver or bile duct disease, steroid exposure, and growth in young pets.',
  'guide.labGlossary.marker.tacrolimus.typical': 'Often ~20–150 U/L in adult dogs/cats (method dependent).',
  'guide.labGlossary.marker.tacrolimus.note': 'Mild isolated rises can be non-specific; trend and context matter.',
  'guide.labGlossary.marker.ciclosporin.name': 'GGT (Gamma-Glutamyl Transferase)',
  'guide.labGlossary.marker.ciclosporin.abbr': 'GGT',
  'guide.labGlossary.marker.ciclosporin.category': 'Liver',
  'guide.labGlossary.marker.ciclosporin.why': 'GGT helps assess bile flow and hepatobiliary disease, often interpreted alongside ALP and bilirubin.',
  'guide.labGlossary.marker.ciclosporin.typical': 'Often low in healthy pets; reference limits vary by lab.',
  'guide.labGlossary.marker.mmf.name': 'Total Protein',
  'guide.labGlossary.marker.mmf.abbr': 'TP',
  'guide.labGlossary.marker.mmf.category': 'Proteins & Other',
  'guide.labGlossary.marker.mmf.why': 'Total protein combines albumin and globulins and can reflect hydration, inflammation, or protein loss.',
  'guide.labGlossary.marker.mmf.typical': 'Dog: ~5.5–7.5 g/dL · Cat: ~6.0–8.0 g/dL.',
  'guide.labGlossary.marker.potassium.name': 'Potassium',
  'guide.labGlossary.marker.potassium.abbr': 'K+',
  'guide.labGlossary.marker.potassium.category': 'Electrolytes',
  'guide.labGlossary.marker.potassium.why': 'Potassium affects heart and muscle function. Abnormal values may occur with kidney/urinary disease, vomiting, diarrhea, or urinary blockage.',
  'guide.labGlossary.marker.potassium.typical': 'Dog/Cat commonly ~3.5–5.5 mmol/L.',
  'guide.labGlossary.marker.potassium.note': 'Urgent abnormalities can occur with blocked cats and severe dehydration.',
  'guide.labGlossary.marker.sodium.name': 'Sodium',
  'guide.labGlossary.marker.sodium.abbr': 'Na+',
  'guide.labGlossary.marker.sodium.category': 'Electrolytes',
  'guide.labGlossary.marker.sodium.why': 'Sodium reflects fluid balance and can shift with dehydration, endocrine disease, and kidney/urinary issues.',
  'guide.labGlossary.marker.sodium.typical': 'Dog/Cat commonly ~140–160 mmol/L.',
  'guide.labGlossary.marker.bicarbonate.name': 'Chloride',
  'guide.labGlossary.marker.bicarbonate.abbr': 'Cl−',
  'guide.labGlossary.marker.bicarbonate.category': 'Electrolytes',
  'guide.labGlossary.marker.bicarbonate.why': 'Chloride helps acid-base and hydration assessment, especially with sodium and bicarbonate.',
  'guide.labGlossary.marker.bicarbonate.typical': 'Dog/Cat commonly ~105–122 mmol/L.',
  'guide.labGlossary.marker.phosphate.name': 'Phosphorus',
  'guide.labGlossary.marker.phosphate.abbr': 'PHOS',
  'guide.labGlossary.marker.phosphate.category': 'Kidney & Urinary',
  'guide.labGlossary.marker.phosphate.why': 'Phosphorus often rises as kidney disease progresses and is important for CKD staging and nutrition planning.',
  'guide.labGlossary.marker.phosphate.typical': 'Dog: ~2.5–6.0 mg/dL · Cat: ~2.5–6.8 mg/dL.',
  'guide.labGlossary.marker.calcium.name': 'Calcium',
  'guide.labGlossary.marker.calcium.abbr': 'Ca',
  'guide.labGlossary.marker.calcium.category': 'Electrolytes',
  'guide.labGlossary.marker.calcium.why': 'Calcium is important for nerves, muscle, and bones. Values may change with kidney disease, cancer, endocrine disorders, or low albumin.',
  'guide.labGlossary.marker.calcium.typical': 'Total calcium often ~8.5–11.8 mg/dL (species/lab dependent).',
  'guide.labGlossary.marker.haemoglobin.name': 'Red Cell Status',
  'guide.labGlossary.marker.haemoglobin.abbr': 'HGB / HCT / RBC',
  'guide.labGlossary.marker.haemoglobin.category': 'CBC',
  'guide.labGlossary.marker.haemoglobin.why': 'Red cell measurements assess anemia or dehydration. Chronic kidney disease can reduce red blood cell production.',
  'guide.labGlossary.marker.haemoglobin.typical': 'Ranges vary by species and analyzer; use your report\'s HGB/HCT/RBC intervals.',
  'guide.labGlossary.marker.wbc.name': 'White Blood Cell Count',
  'guide.labGlossary.marker.wbc.abbr': 'WBC',
  'guide.labGlossary.marker.wbc.category': 'CBC',
  'guide.labGlossary.marker.wbc.why': 'WBC helps assess inflammation, infection, stress response, and some bone marrow disorders.',
  'guide.labGlossary.marker.wbc.typical': 'Dog roughly ~6–17 ×10⁹/L · Cat ~5–19 ×10⁹/L.',
  'guide.labGlossary.marker.wbc.note': 'Look at differential counts (neutrophils/lymphocytes/eosinophils) for full interpretation.',
  'guide.labGlossary.marker.platelets.name': 'Platelets',
  'guide.labGlossary.marker.platelets.abbr': 'PLT',
  'guide.labGlossary.marker.platelets.category': 'CBC',
  'guide.labGlossary.marker.platelets.why': 'Platelets support blood clotting. Low platelets may increase bleeding risk; false lows can occur from platelet clumping.',
  'guide.labGlossary.marker.platelets.typical': 'Commonly ~200–500 ×10⁹/L (method dependent).',
  'guide.labGlossary.marker.altAst.name': 'ALT / AST',
  'guide.labGlossary.marker.altAst.abbr': 'ALT / AST',
  'guide.labGlossary.marker.altAst.category': 'Liver',
  'guide.labGlossary.marker.altAst.why': 'ALT/AST are liver-associated enzymes. Increases can reflect liver cell injury, inflammation, toxins, or muscle injury (especially AST).',
  'guide.labGlossary.marker.altAst.typical': 'Lab-specific; ALT is usually the more liver-specific value in dogs and cats.',
  'guide.labGlossary.marker.uricAcid.name': 'Albumin',
  'guide.labGlossary.marker.uricAcid.abbr': 'ALB',
  'guide.labGlossary.marker.uricAcid.category': 'Proteins & Other',
  'guide.labGlossary.marker.uricAcid.why': 'Albumin is a key blood protein that can drop with chronic inflammation, protein-losing kidney/gut disease, or liver dysfunction.',
  'guide.labGlossary.marker.uricAcid.typical': 'Dog: ~2.6–4.0 g/dL · Cat: ~2.5–3.9 g/dL.',
  'guide.labGlossary.marker.hba1c.name': 'Glucose',
  'guide.labGlossary.marker.hba1c.abbr': 'GLU',
  'guide.labGlossary.marker.hba1c.category': 'Metabolic',
  'guide.labGlossary.marker.hba1c.why': 'Glucose helps screen for diabetes and stress hyperglycemia (common in cats).',
  'guide.labGlossary.marker.hba1c.typical': 'Dog: ~70–120 mg/dL · Cat: ~70–150 mg/dL.',
  'guide.labGlossary.marker.cmv.name': 'Globulin',
  'guide.labGlossary.marker.cmv.abbr': 'GLOB',
  'guide.labGlossary.marker.cmv.category': 'Proteins & Other',
  'guide.labGlossary.marker.cmv.why': 'Globulins can increase with inflammation/infection and decrease with some immune or protein-losing disorders.',
  'guide.labGlossary.marker.cmv.typical': 'Dog: ~2.0–3.8 g/dL · Cat: ~2.8–5.1 g/dL.',
  'guide.labGlossary.marker.cmv.note': 'Interpret with albumin and total protein (A:G ratio is often useful).',
  'guide.labGlossary.marker.bkv.name': 'Bilirubin',
  'guide.labGlossary.marker.bkv.abbr': 'TBIL',
  'guide.labGlossary.marker.bkv.category': 'Liver',
  'guide.labGlossary.marker.bkv.why': 'Bilirubin can rise with liver disease, bile duct obstruction, or increased red blood cell breakdown.',
  'guide.labGlossary.marker.bkv.typical': 'Usually low/near-zero in healthy pets (lab dependent).',
  'guide.labGlossary.marker.upcr.name': 'Urine Protein:Creatinine Ratio',
  'guide.labGlossary.marker.upcr.abbr': 'UPC / UPCR',
  'guide.labGlossary.marker.upcr.category': 'Kidney & Urinary',
  'guide.labGlossary.marker.upcr.why': 'UPC estimates how much protein is lost in urine and helps monitor kidney disease progression and response to treatment.',
  'guide.labGlossary.marker.upcr.typical': 'Dog/Cat: <0.2 non-proteinuric, 0.2–0.5 borderline, >0.5 proteinuric (context matters).',
  'guide.labGlossary.marker.c0d.name': 'Urine Specific Gravity',
  'guide.labGlossary.marker.c0d.abbr': 'USG',
  'guide.labGlossary.marker.c0d.category': 'Kidney & Urinary',
  'guide.labGlossary.marker.c0d.why': 'USG measures urine concentration and is essential for interpreting kidney values and hydration status.',
  'guide.labGlossary.marker.c0d.typical': 'Highly variable; persistently low USG with high kidney markers may indicate kidney dysfunction.',
  'guide.labGlossary.category.kidneyFunction': 'Kidney & Urinary',
  'guide.labGlossary.category.immunosuppressants': 'Chemistry',
  'guide.labGlossary.category.electrolytes': 'Electrolytes',
  'guide.labGlossary.category.bloodCount': 'CBC',
  'guide.labGlossary.category.liverFunction': 'Liver',
  'guide.labGlossary.category.metabolic': 'Metabolic',
  'guide.labGlossary.category.infections': 'Proteins & Other',
  // Register legal
  'register.byRegistering': "En vous inscrivant, vous acceptez nos",
  'register.and': 'et',
  'register.termsOfService': "Conditions d'utilisation",
  'register.privacyPolicy': 'Politique de confidentialité',
  // CSV headers
  'records.csv.date': 'Date',
  'records.csv.weight': 'Poids',
  'records.csv.fluidIn': 'Apport liquidien',
  'records.csv.urineOut': 'Urine',
  'records.csv.amRegistered': 'Matin Enregistré',
  'records.csv.amBP': 'TA Matin',
  'records.csv.amPulse': 'Pouls Matin',
  'records.csv.amTemp': 'Temp. Matin',
  'records.csv.pmRegistered': 'Soir Enregistré',
  'records.csv.pmBP': 'TA Soir',
  'records.csv.pmPulse': 'Pouls Soir',
  'records.csv.pmTemp': 'Temp. Soir',
  'records.csv.observations': 'Observations',
  'records.csv.healthDiary': 'Journal de santé',
  // Roomies settings
  'options.roomies.description': 'Connectez-vous avec des patients post-transplantés de votre groupe. Toute activité est anonyme.',
  'options.roomies.nickname': 'Pseudo',
  'options.roomies.nicknameMax': '(max 12 car.)',
  'options.roomies.nicknamePlaceholder': 'ex. Phoenix',
  'options.roomies.beanColour': 'Couleur du BEAN',
  'options.roomies.groupCode': 'Code de groupe',
  'options.roomies.groupCodePlaceholder': 'Entrez ou partagez votre code de groupe',
  'options.roomies.groupCodeHint': "Partagez ce code avec vos roomies de l'hôpital pour qu'ils rejoignent votre groupe.",
  'options.roomies.enableRoomies': 'Activer les Roomies',
  'options.roomies.enableRoomiesHint': 'Autoriser votre activité à apparaître dans le fil du groupe',
  'options.roomies.noChanges': 'Aucune modification à enregistrer',
  'options.roomies.saveProfile': 'Enregistrer le profil Roomie',
  'options.roomies.saved': 'Profil Roomie enregistré !',
  // Companionship (The Koda Fellowship)
  'companions.title': 'Compagnonnage',
  'companions.pageTitle': 'La Confrérie Koda',
  'companions.subtitle': 'Découvre comment ton animal se classe parmi les compagnons du monde entier.',
  'companions.publicView': 'Vue publique',
  'companions.publicViewHint': 'Lorsqu’elle est activée, ton animal apparaît dans le classement mondial de la Confrérie Koda. Désactive-la pour rester privé — tu peux toujours voir les autres.',
  'companions.publicViewOn': 'Visible dans le classement',
  'companions.publicViewOff': 'Masqué dans le classement',
  'companions.leaderboardTitle': 'Classement',
  'companions.leaderboardEmpty': 'Pas encore de companions — sois le premier !',
  'companions.leaderboardHint': 'Classé par niveau et série actuelle. Touche un emoji pour les encourager.',
  'companions.you': 'Toi',
  'companions.rank': 'Rang',
  'companions.score': 'Score',
  'companions.levelShort': 'Niv {n}',
  'companions.streakShort': 'Série de {n} j',
  'companions.hiddenNotice': 'Tu es masqué du classement. Active la Vue publique dans Réglages.',
  'companions.tabAll': 'Toujours',
  'companions.tabWeek': 'Cette semaine',
  'companions.weekXPShort': '+{n} XP cette semaine',
  'companions.leaderboardEmptyWeek': 'Aucun XP cette semaine — enregistre les constantes pour grimper !',
  'companions.leaderboardHintWeek': 'Classé selon les XP gagnés depuis lundi. Réinitialisé chaque semaine.',
  'companions.story.title': 'Story du compagnon',
  'companions.story.modalTitle': 'Ta story de compagnon',
  'companions.story.hint': 'Choisis une puce et écris une courte note. Elle apparaît sous ta ligne dans le classement.',
  'companions.story.placeholder': 'Quoi de neuf avec ton compagnon ?',
  'companions.story.save': 'Enregistrer',
  'companions.story.edit': 'Modifier la story',
  'companions.story.clear': 'Effacer la story',
  'companions.story.expiresIn': 'Expire dans {n} j',
  'companions.story.recovered': 'Rétabli',
  'companions.story.vaccinated': 'Vacciné',
  'companions.story.grooming': 'Toilettage',
  'companions.story.vetVisit': 'Chez le véto',
  'companions.story.newTreat': 'Nouvelle friandise',
  'companions.story.birthday': 'Anniversaire !',
  'companions.story.feelingGreat': 'En grande forme',
  'companions.story.restingUp': 'Au repos',
  'companions.story.newHome': 'Nouveau foyer',
  // Bean page
  'bean.back': 'Retour',
  'bean.level': 'Niveau',
  'bean.yourBean': 'Votre BEAN',
  'bean.dailyStreak': 'Série quotidienne',
  'bean.current': 'Actuel',
  'bean.best': 'Meilleur',
  'bean.totalXP': 'XP total',
  'bean.streakZero': 'Enregistre tes constantes aujourd\'hui pour démarrer ta série !',
  'bean.last30Days': '30 derniers jours',
  'bean.roomies': 'Compagnonnage',
  'bean.active': 'Actif',
  'bean.connectText': 'Connecte-toi avec d’autres propriétaires d’animaux dans le monde. Encouragez-vous dans le classement — anonymement.',
  'bean.setupRoomies': 'Active la Vue publique dans Réglages → Compagnonnage pour apparaître dans le classement.',
  'bean.roomiesSettings': 'Réglages Companion',
  'bean.preview': 'Aperçu',
  'bean.noActivity': 'Aucun companion pour l’instant — ils apparaîtront ici au fur et à mesure.',
  'bean.keepGoing': 'Continuez !',
  'bean.justNow': "à l'instant",
  'bean.minsAgo': 'il y a {n}min',
  'bean.hoursAgo': 'il y a {n}h',
  'bean.daysAgo': 'il y a {n}j',
  'bean.levelName.seedling': 'Graine',
  'trial.endsToday': 'Votre essai se termine aujourd’hui — passez à niveau maintenant pour conserver vos données.',
  'trial.endsIn': 'L’essai se termine dans {days} jour{s} — passez à niveau pour conserver l’accès.',
  'trial.upgrade': 'Passer à niveau',
  'trial.dismiss': 'Fermer',
  'layout.offlineBanner': 'Vous êtes hors ligne — les changements se synchroniseront à la reconnexion',
  'layout.reconnectSyncing': 'De retour en ligne — synchronisation de {n} élément(s) en attente…',
  'layout.reconnectSynced': 'Toutes les modifications sont synchronisées ✓',
  'splash.preparing': 'Nous préparons tout pour vous...',
  'bean.levelName.sprouting': 'Germination',
  'bean.levelName.budding': 'Bourgeon',
  'bean.levelName.rooted': 'Enraciné',
  'bean.levelName.thriving': 'Florissant',
  'bean.levelName.flourishing': 'Épanouissement',
  'bean.levelName.resilient': 'Résilient',
  'bean.levelName.champion': 'Champion',
  'bean.levelName.guardian': 'Gardien',
  'bean.levelName.legend': 'Légende',
  'bean.feed.dailyLog': 'a enregistré ses constantes aujourd\'hui',
  'bean.feed.dailyLogStreak': 'a enregistré ses constantes 🔥 série de {n} jours',
  'bean.feed.streakMilestone': 'a atteint une série de {n} jours ! 🎉',
  'bean.feed.guideArticle': 'a lu un article du guide',
  'bean.feed.joinedGroup': 'a rejoint le groupe',
  'bean.feed.changedLook': 'a mis à jour son look BEAN 🎨',
  'bean.celebration.levelUpTitle': 'Niveau {level} ! 🎉',
  'bean.celebration.streakTitle': 'Série de {streak} jours ! 🔥',
  'bean.celebration.levelUpBody': 'Vous avez atteint {name}. Continuez !',
  'bean.celebration.streakBody': '{streak} jours de suite — une régularité incroyable !',
  // Notifications
  'notifications.medReminder': 'Rappel médicament',
  'notifications.medReminderBody': 'Heure de prendre : {meds}',
  'notifications.dailyReminder': 'Rappel journal quotidien',
  'notifications.dailyReminderBody': "Vous n'avez pas enregistré de données aujourd'hui. L'enregistrement de vos constantes aide à suivre votre santé.",
  'notifications.alarmTitle': '💊 Rappel médicament',
  'notifications.alarmBody': 'Heure de prendre {name} ({dosage})',
  // Guide / Library page
  'guide.articles': 'Articles',
  'guide.subtitle': 'Guides, outils & dossiers de votre animal.',
  'guide.resources': 'Ressources',
  'guide.minRead': 'min de lecture',
  'guide.unlocksInDay': 'Disponible dans {n} jour',
  'guide.unlocksInDays': 'Disponible dans {n} jours',
  'guide.category.contacts.title': 'Contacts Médicaux',
  'guide.category.contacts.subtitle': 'Tout en un endroit sûr.',
  'guide.category.medical_card.title': 'Carte Médicale',
  'guide.category.medical_card.subtitle': "Votre carte d'identité médicale.",
  'guide.category.emergency.title': 'Urgence vétérinaire',
  'guide.category.emergency.subtitle': 'Trouver immédiatement le service vétérinaire le plus proche.',
  'guide.category.how_to.title': 'Guide: vérifier les constantes',
  'guide.category.how_to.subtitle': 'Étapes par type d’animal.',
  'guide.category.hygiene.title': 'Hygiène',
  'guide.category.hygiene.subtitle': "La nouvelle normalité : guide moderne d'hygiène post-transplantation",
  'guide.category.exercise.title': 'Exercice',
  'guide.category.exercise.subtitle': "Le pouvoir du mouvement : guide d'exercice post-transplantation",
  'guide.category.wellbeing.title': 'Bien-Être',
  'guide.category.wellbeing.subtitle': "Humeur, état d'esprit et habitudes",
  'guide.category.food.title': 'Alimentation',
  'guide.category.food.subtitle': 'Bien manger après votre transplantation',
  'guide.category.nutrition.title': 'Alimentation',
  'guide.category.nutrition.subtitle': 'Bien manger après votre transplantation',
  'guide.category.sleep.title': 'Sommeil',
  'guide.category.sleep.subtitle': 'Repos et routines du coucher',
  'guide.category.lab_glossary.title': 'Glossaire Labo',
  'guide.category.lab_glossary.subtitle': 'Comprendre vos résultats',
  'guide.category.vault.title': 'Dossiers médicaux',
  'guide.category.vault.subtitle': 'Télécharger, stocker et consulter.',
  'guide.category.reminders.title': 'Rappels',
  'guide.category.reminders.subtitle': 'Alertes médicaments.',
  'guide.category.co-carers.title': 'Co-Carers',
  'guide.category.co-carers.subtitle': 'Share care with someone else.',
  // Auth — Register
  'register.disclaimerPrefix': 'Je comprends que KodaCare est un outil de suivi de santé, et non un dispositif médical, et j\'accepte la',
  'register.passwordStrength': 'Force :',
  'register.rule.minLength': 'Au moins 8 caractères',
  'register.rule.uppercase': 'Lettre majuscule (A–Z)',
  'register.rule.lowercase': 'Lettre minuscule (a–z)',
  'register.rule.number': 'Chiffre (0–9)',
  'register.rule.special': 'Caractère spécial (!@#$…)',
  'register.strength.veryWeak': 'Très faible',
  'register.strength.weak': 'Faible',
  'register.strength.fair': 'Moyen',
  'register.strength.strong': 'Fort',
  'register.strength.veryStrong': 'Très fort',
  'register.error.emailInUse': 'Un compte avec cet e-mail existe déjà.',
  'register.error.invalidEmail': 'Veuillez entrer une adresse e-mail valide.',
  'register.error.weakPassword': 'Mot de passe trop faible. Veuillez en choisir un plus robuste.',
  'register.error.network': 'Erreur réseau. Vérifiez votre connexion et réessayez.',
  'register.error.generic': 'Inscription échouée. Veuillez réessayer.',
  'register.error.passwordRequirements': 'Veuillez satisfaire toutes les exigences du mot de passe.',
  'register.error.passwordsMustMatch': 'Les mots de passe ne correspondent pas.',
  'register.error.googleFailed': 'Connexion Google échouée. Veuillez réessayer.',
  // Auth — Login
  'login.error.incorrectCredentials': 'E-mail ou mot de passe incorrect.',
  'login.error.notVerified': 'Votre adresse e-mail n\'a pas été vérifiée. Vérifiez votre boîte de réception.',
  'login.error.tooManyRequests': 'Trop de tentatives. Veuillez réessayer plus tard.',
  'login.error.network': 'Erreur réseau. Vérifiez votre connexion et réessayez.',
  'login.error.generic': 'Connexion échouée. Veuillez réessayer.',
  'login.error.googleFailed': 'Connexion Google échouée. Veuillez réessayer.',
  // Medical Card
  'medcard.title': 'Carte d\'identité médicale',
  'medcard.saveTitleAttr': 'Sauvegarder dans le profil',
  'medcard.saved': 'Enregistré ✓',
  'medcard.saving': 'Enregistrement…',
  'medcard.save': 'Sauvegarder',
  'medcard.shareAlt': 'Partager comme image',
  'medcard.shareFailed': 'Partage échoué',
  'medcard.hint': 'Appuyez sur un champ pour modifier · Appuyez sur Sauvegarder pour synchroniser',
  'medcard.diary.title': 'Journal de santé',
  'medcard.diary.placeholder': "Écrivez tout sur aujourd'hui : observations, disposition générale, signes de bonne et mauvaise santé…",
  'medcard.diary.saved': 'Enregistré',
  'medcard.diary.saving': 'Enregistrement…',
  'medcard.fullName': "Nom du Hooman",
  'medcard.profession': "Nom de l'animal",
  'medcard.dob': 'Race',
  'medcard.transplantDate': 'Date de transplantation',
  'medcard.hospital': 'Hôpital',
  'medcard.processNo': 'No. de dossier',
  'medcard.surgeon': 'Néphrologue',
  'medcard.allergies': 'Allergies',
  'medcard.avgWeight': 'Poids moy.',
  'medcard.medications': 'Médicaments actuels',
  'medcard.avgBP': 'TA moy.',
  'medcard.placeholder.name': 'Appuyer pour saisir le nom',
  'medcard.placeholder.profession': 'Appuyer pour saisir',
  'medcard.placeholder.dob': 'ex. Européen à poils courts',
  'medcard.placeholder.hospital': 'Nom de l\'hôpital',
  'medcard.placeholder.processNo': 'ex. 123456',
  'medcard.placeholder.surgeon': 'Nom du néphrologue',
  'medcard.placeholder.allergies': 'Aucune connue',
  // Records — Today's Card
  'records.todaysCard': 'Carte du jour',
  'records.todaysCardComplete': 'Carte du jour complète !',
  'records.allThreeLogged': 'Les trois étapes enregistrées — bravo pour aujourd\'hui.',
  'records.filesTooLarge': '{n} fichier(s) ignoré(s) supérieur(s) à {mb} Mo.',
  'records.stepLocked': 'Verrouillé',
  // Trends
  'trends.showLast': 'Afficher les derniers :',
  // Guide wrappers
  'guide.renderError': 'Erreur de rendu du contenu :',
  // AppointmentCalendar
  'appt.kind.checkup': 'Contrôle',
  'appt.kind.lab': 'Labo',
  'appt.kind.medication': 'Médication',
  'appt.kind.other': 'Autre',
  'appt.noAppointments': 'Aucun rendez-vous ce jour',
  'appt.upcoming': 'À venir',
  'appt.today': "Aujourd'hui",
  'appt.addEvent': 'Ajouter un événement',
  'appt.editEvent': 'Modifier l’événement',
  'appt.titleLabel': 'Titre',
  'appt.titlePlaceholder': 'ex. Rappel de vaccin',
  'appt.dateLabel': 'Date',
  'appt.timeLabel': 'Heure',
  'appt.kindLabel': 'Type',
  'appt.doctorLabel': 'Vétérinaire',
  'appt.doctorPlaceholder': 'Facultatif',
  'appt.locationLabel': 'Lieu',
  'appt.locationPlaceholder': 'Facultatif',
  'appt.save': 'Enregistrer',
  'appt.cancel': 'Annuler',
  'appt.delete': 'Supprimer',
  'appt.deleteConfirm': 'Supprimer cet événement ?',
  // Records share
  'records.weekOf': 'Semaine du',
  'records.share.title': 'Résumé quotidien KodaCare',
  'records.share.weight': 'Poids :',
  'records.share.morning': 'Matin :',
  'records.share.afternoon': 'Après-midi :',
  'records.share.fluidInOut': 'Apport liquidien : {fluidIn}  |  Urine : {fluidOut}',
  'records.share.note': 'Note :',
  'records.share.dataTitle': 'Données de santé KodaCare',
  'records.share.dataText': 'Mes données de santé KodaCare - {date}',
  // Notifications accessibility
  'notifications.dismiss': 'Fermer',
  'notifications.bellLabel': 'Notifications',
  'notifications.settingsLabel': 'Paramètres de notification',
  'notifications.fallbackTitle': 'Rappel KodaCare',
  'fab.voiceHint': 'Quand vous êtes prêt, dites « Démarrer chrono Koda »',
  'fab.voicePhrase': 'démarrer chrono koda',
  'notifications.fallbackBody': 'Vous avez un nouveau rappel.',
  // Vitals redesign stubs
  'records.heartRate': 'Heart Rate',
  'records.respRate': 'Respiratory Rate',
  'records.heartRateRecorded': 'Heart Rate Recorded',
  'records.respRateRecorded': 'Respiratory Rate Recorded',
  'records.temperatureRecorded': 'Temperature Recorded',
  'records.undoHeartRate': 'Undo heart rate',
  'records.undoRespRate': 'Undo respiratory rate',
  'records.undoTemperature': 'Undo temperature',
  'records.wellnessCheck': 'Wellness',
  'records.mucousMembranes': 'Mucous Membranes',
  'records.mm.pink': 'Pink',
  'records.mm.red': 'Red',
  'records.mm.blue': 'Blue',
  'records.mm.white': 'White',
  'records.csv.heartRate': 'Heart Rate (bpm)',
  'records.csv.respRate': 'Resp. Rate (bpm)',
  'records.csv.mucousMembrane': 'Mucous Membrane',
  'records.csv.temp': 'Temp',
  'records.share.fluidIn': 'Fluid In',
  'records.countFor15s': 'Count beats for 15 seconds',
  'records.countBreathsFor15s': 'Count breaths for 15 seconds',
  'records.beats': 'beats',
  'records.breaths': 'breaths',
  'records.saveHeartRate': 'Save Heart Rate',
  'records.saveRespRate': 'Save Respiratory Rate',
  'records.temperature': 'Temperature',
  'records.saveTemperature': 'Save Temperature',
  // Onboarding walkthrough
  'walkthrough.polyName': 'Koda',
  'walkthrough.skip': 'Passer',
  'walkthrough.back': 'Retour',
  'walkthrough.letsGo': 'Allons-y',
  'walkthrough.next': 'Suivant',
  'walkthrough.finish': 'Terminé ! 🎉',
  'walkthrough.step0.title': 'Bonjour, je suis Koda !',
  'walkthrough.step0.body': "Ravi de vous rencontrer ! J'ai préparé un cadeau de bienvenue de +30 XP pour vous. Plus à ce sujet plus tard… Je vais vous faire visiter.",
  'walkthrough.step1.title': 'Entrée quotidienne',
  'walkthrough.step1.body': "Enregistrez les constantes de votre animal ici aussi souvent que possible — chaque jour est parfait.",
  'walkthrough.step2.title': 'Tendances de santé',
  'walkthrough.step2.body': "Voyez comment la santé de votre animal évolue dans le temps grâce à ces graphiques.",
  'walkthrough.step3.title': 'Médicaments',
  'walkthrough.step3.body': 'Suivez les médicaments, les horaires et les doses — ne manquez jamais une dose grâce aux rappels directement sur votre appareil.',
  'walkthrough.step4.title': 'Votre bibliothèque de soins',
  'walkthrough.step4.body': "Tout au même endroit — guides pour gagner des XP, la carte d'identité de votre animal, contacts de l'équipe soignante, dossiers vétérinaires et plus. Appuyez sur une ressource pour commencer.",
  'walkthrough.step5.title': 'Votre progression',
  'walkthrough.step5.body': "Suivez vos séries et votre progression XP, et rencontrez d'autres soignants dans les tableaux de Compagnonnage.",
  'options.replayWalkthrough': "Rejouer l’introduction",
  'members.title': 'Co-soignants',
  'members.membersTitle': 'Membres actuels',
  'members.inviteTitle': 'Inviter un co-soignant',
  'members.inviteHint': "Crée un lien d'invitation sécurisé et partage-le directement via iMessage, WhatsApp ou toute autre messagerie.",
  'members.createLink': "Créer un lien d'invitation",
  'members.copyLink': 'Copier le lien',
  'members.copied': 'Copié !',
  'members.linkCopied': 'Lien copié — partage-le avec ton co-soignant.',
  'members.inviteError': "Impossible de créer l'invitation. Veuillez réessayer.",
  'members.pendingTitle': 'Invitations en attente',
  'members.cancelInvite': 'Annuler',
  'members.owner': 'Propriétaire',
  'members.remove': "Retirer l’accès",
  'members.confirmRemove': "Retirer {name} en tant que co-soignant ?",
  'members.joinedOn': 'Rejoint le',
  'members.sentOn': 'Envoyé le',
  'members.loading': 'Chargement…',
  'members.noMembers': "Aucun membre pour l’instant.",
  'members.viewOnlyNotice': "Vous êtes co-soignant de cet animal. Seul le propriétaire peut gérer l’accès.",
  'members.coCarers': 'Co-soignants',
  'members.coCarersSubtitle': "Partager les soins de cet animal avec quelqu'un d'autre",
  'members.transferTitle': 'Transférer la propriété',
  'members.transferHint': "Transférez la pleine propriété du profil de {petName} à un autre utilisateur KodaCare. Le destinataire doit disposer d'un abonnement actif. Vous resterez co-soignant après le transfert.",
  'members.transferWarning': 'Cette action est permanente et irréversible. Vous perdrez vos droits de propriétaire sur cet animal.',
  'members.transferEmail': 'Adresse e-mail du destinataire',
  'members.transferSelectCarer': 'Sélectionner un co-soignant existant :',
  'members.transferAction': 'Transférer',
  'members.transferConfirm': 'Transférer la propriété de {petName} à {email} ? Cette action est irréversible.',
  'members.transferSuccess': 'Propriété transférée. Vous êtes maintenant co-soignant de cet animal.',
  'members.transferError': 'Impossible de transférer la propriété. Veuillez réessayer.',
  'coCarer.removedNotice.title': 'Vous avez été retiré',
  'coCarer.removedNotice.body': 'Le propriétaire vous a retiré comme co-soignant de {petName}. Le profil et les données de cet animal n’apparaîtront plus dans votre compte.',
  'coCarer.removedNotice.ok': 'OK',
  'doses.markAsGiven': 'Marquer comme donné',
  'doses.givenBy': 'Donné par',
  'doses.at': 'à',
  'doses.alreadyGiven': 'Déjà donné',
};
